import styles from './StylesTab.css';

export default function ImagesTab() {
  return (
    <div>
        <p>user images</p>
    </div>
  )
}
